import React from 'react';
import { Dialog, DialogContent, Box } from '@mui/material';
import Signup from '../signup/Signup';
import { primitiveGradients, semanticColors, BORDER_RADIUS } from '@/theme/tokens';

interface SignupModalProps {
  open: boolean;
  onSignupComplete: () => void;
  onDismiss: () => void;
}

/**
 * Address / consent signup flow as a modal over the main app (e.g. guest chat).
 * Backdrop click, Escape, and the close icon all call onDismiss (sign out).
 */
const SignupModal: React.FC<SignupModalProps> = ({ open, onSignupComplete, onDismiss }) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      disableEnforceFocus
      maxWidth="sm"
      fullWidth
      scroll="paper"
      aria-labelledby="signup-modal-title"
      sx={{
        zIndex: (theme) => theme.zIndex.modal,
        '& .MuiDialog-paper': {
          borderRadius: BORDER_RADIUS,
          overflow: 'hidden',
          backgroundColor: semanticColors.surface,
          maxWidth: '520px',
          maxHeight: { xs: '100vh', sm: 'min(92vh, 900px)' },
          margin: { xs: 1, sm: 2 },
          width: { xs: 'calc(100% - 16px)', sm: 'auto' },
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15), 0 1px 3px rgba(0, 0, 0, 0.08)',
        },
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
    >
      <Box sx={{ height: '4px', background: primitiveGradients.primary, flexShrink: 0 }} />

      <DialogContent
        sx={{
          px: { xs: 1.5, sm: 3 },
          pt: { xs: 2, sm: 3 },
          pb: { xs: 2, sm: 3 },
          position: 'relative',
          overflowY: 'auto',
        }}
      >
        <Box id="signup-modal-title" sx={{ pt: 0.5 }}>
          <Signup onSignupComplete={onSignupComplete} onGoBack={onDismiss} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SignupModal;
